// extracted by mini-css-extract-plugin
module.exports = {"tableCard":"DataTable_tableCard__18FB5","title":"DataTable_title__3_SY3"};